module.exports = __webpack_public_path__ + "img/add.5062e80a.svg";